import React from 'react'

const FloatCard = ({ children, className = '' }) => {
  return (
    <div
      className={`rounded-card border border-line bg-white shadow-card ${className}`}
    >
      {children}
    </div>
  )
}

export default FloatCard
